/**
 * Convert an arbitrary string (e.g. a company legal name) into a URL-safe,
 * lowercase, hyphen-separated slug for use in vanity URLs like
 * `/company/123-acme-corp/target`.
 *
 * This is for readability only (sharing/revisiting links) - it is never used
 * to look up or identify a record.
 *
 * @param {string} value
 * @returns {string}
 */
export default function slugify(value) {
  if (!value) return '';

  return value
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 80);
}
